var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{attrs:{"classes":_vm.computedClass,"label":_vm.label,"size":_vm.size,"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }